import { Component, ElementRef, HostListener, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';
import { Router, RouterOutlet } from '@angular/router';
import { select, Store } from '@ngrx/store';
import {
  ApiService,
  CoreUiPartialState,
  DialogService,
  ElectronService,
  getBranch,
  getCashDrawer,
  getHasActiveOrder,
  getHasLoadedGiftCards,
  getIsIncompleteOrder,
  getParkedOrderListLength,
  getUserId,
  getUserName,
  getUserRole,
  hasUnsavedChanges,
  loadArbCentralNavSecurity,
  MessageService,
  resetAllFlags,
  setCashDrawer,
} from '@pos-app/core-ui';
import { ProductSpotlightComponent } from '@pos-app/core-ui/lib/components/product-spotlight/product-spotlight.component';
import { SecureCatalogueService } from '@pos-app/core-ui/lib/services/secure-catelogue.service';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { finalize, switchMap, take, takeUntil } from 'rxjs/operators';
import { ScrollService } from '../../services/scroll.service';
import { LayoutService } from '@pos-app/core-ui/lib/services/layout.service';
import { Branch, KEYS, USER_ROLE } from '@pos-app/data';
import { OOESessionService } from '@pos-app/core-ui/lib/services/ooe-session.service';
import { NavBarComponent } from '@pos-app/core-ui/lib/components/nav-bar/nav-bar.component';
import { CentralPartialState } from '../../../features/central/+state/central.reducer';
import { centralQuery } from '../../../features/central/+state/central.selectors';
import { LoadCentralTasks, LoadOpenJobRequestTotals } from '../../../features/central/+state/central.actions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CoreUiModule } from '../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgIf, NgStyle, NgFor, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';

@Component({
    selector: 'pos-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [CoreUiModule, MatDrawerContainer, NgIf, MatDrawer, NgStyle, MatIcon, MatDrawerContent, RouterOutlet, FormsModule, ReactiveFormsModule, NgSelectComponent, NgFor, NgOptionComponent, AsyncPipe]
})
export class NavbarComponent implements OnInit {
  @ViewChild('spotlightElement') spotlightElement: ProductSpotlightComponent;
  @ViewChild('sidenav') sidenav: ElementRef;
  @ViewChild('drawer') drawer: MatDrawer;
  @ViewChild('logoContainer', { read: ElementRef }) logoContainer: ElementRef;
  @ViewChild(NavBarComponent) navBarComponent!: NavBarComponent;
  @ViewChild('content') modalBox: any;

  @Input() drawerStatus = false;
  hoverStatus = false;
  showSpotlightNav: boolean;
  loggedinUserId$: Observable<string>;
  sideNaveWidth: any;
  hasUnsavedChanges: boolean;
  private unSubscribe$ = new Subject<void>();
  menuHide: boolean;
  timer: any;
  public innerWidth: any;
  isMinimized: boolean = false;
  isMaximized: boolean = false;
  isAutoHide: boolean = false;
  menuDisplayPreference: string = 'initial';
  loggedinUserName$: Observable<string>;
  defaultBranch$: Observable<Branch>;
  USER_ROLE = USER_ROLE;
  role$: Observable<string>;
  jdeSession;
  tempDisplayPreference: boolean = false;
  isShowPreferencesSubMenu: boolean = false;
  isShowArbAccountSubMenu: boolean = false;
  scrollDetected: boolean = false;
  centralTaskData$: Observable<any>;
  isChangeBranch: boolean;
  initialBranchCode: Branch;
  changeBranchForm: UntypedFormGroup;
  branchList: Branch[] = [];
  isIncompleteOrder: boolean;
  hasLoadedGiftCards: boolean;
  isElectron = this.electronService.isElectron;
  private _loading$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loading$.asObservable();

  hasActiveOrder: boolean = false; // This should be set based on your application's logic
  hasParkedOrder: boolean;

  constructor(
    private router: Router,
    private store: Store<CoreUiPartialState>,
    private storeCentral: Store<CentralPartialState>,
    public secureCatalogueService: SecureCatalogueService,
    private dialogService: DialogService,
    private scrollService: ScrollService,
    private layoutService: LayoutService,
    private ooeSessionService: OOESessionService,
    private modalService: NgbModal,
    private apiService: ApiService,
    private electronService: ElectronService,
    private messageService: MessageService,
    private toastr: ToastrService
  ) {
    // Subscribe to router events to handle menu display preferences
    const userProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
    if (userProfile?.menuDisplayPreference) {
      this.menuDisplayPreference = userProfile?.menuDisplayPreference ? userProfile?.menuDisplayPreference : 'initial';
    }
    router.events.subscribe((event) => {
      this.handleRouterEvents();
    });
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   this.innerWidth = window.innerWidth;
  //   if (this.innerWidth < 600) {
  //     this.hoverStatus = false;
  //     this.drawer?.close();
  //     this.menuHide = false;
  //   } else {
  //     this.hoverStatus = true;
  //     this.drawer?.open();
  //     this.menuHide = true;
  //   }
  // }

  ngOnInit(): void {
    this.loggedinUserId$ = this.store.pipe(select(getUserId));
    this.loggedinUserName$ = this.store.pipe(select(getUserName));
    this.defaultBranch$ = this.store.pipe(select(getBranch));
    this.role$ = this.store.pipe(select(getUserRole));
    this.jdeSession = JSON.parse(localStorage.getItem(KEYS.jdeSession));
    this.changeBranchForm = new UntypedFormGroup({
      branchCode: new UntypedFormControl('', Validators.required),
    });
    this.loggedinUserId$.pipe(takeUntil(this.unSubscribe$)).subscribe((userId) => {
      if (userId) {
        this.store.dispatch(loadArbCentralNavSecurity());

        setTimeout(() => {
          this.store
            .select(centralQuery.getCentralTaskData)
            .pipe(takeUntil(this.unSubscribe$))
            .subscribe((data: any) => {
              if (!data) {
                this.storeCentral.dispatch(new LoadCentralTasks());
              }
            });
          this.store
            .select(centralQuery.getOpenJobRequestTotals)
            .pipe(takeUntil(this.unSubscribe$))
            .subscribe((data: any) => {
              if (!data) {
                this.storeCentral.dispatch(new LoadOpenJobRequestTotals());
              }
            });
        }, 1000);
      }
      this.store.pipe(select(getBranch)).subscribe((branch) => {
        if (branch) {
          this.initialBranchCode = branch;
        }
      });
      this.changeBranchForm
        .get('branchCode')
        ?.valueChanges.pipe(takeUntil(this.unSubscribe$))
        .subscribe((value) => {
          if (value && value !== this.initialBranchCode?.BranchCode) {
            this.changeBranchForm.get('branchCode')?.setErrors(null);
          } else {
            this.changeBranchForm.get('branchCode')?.setErrors({ notMatching: true });
          }
        });
    });

    document.getElementById('sidenav')?.setAttribute('style', 'width:200px');
    this.store
      .select(getIsIncompleteOrder)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        this.isIncompleteOrder = val;
      });
    this.store
      .select(getHasLoadedGiftCards)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        this.hasLoadedGiftCards = val;
      });
    this.store
      .select(getHasActiveOrder)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        this.hasActiveOrder = val;
      });
    const previousUserProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
    if (previousUserProfile?.newSiteCode) {
      this.toastr.success(`Branch switched to ${previousUserProfile?.DefaultBranchName}`);
      localStorage.setItem(KEYS.jdeSession, JSON.stringify({ ...previousUserProfile, newSiteCode: false }));
      this.store
        .select(getCashDrawer)
        .pipe(take(1))
        .subscribe((cashDrawer) => {
          if (cashDrawer) {
            this.messageService.dispatchAction(
              setCashDrawer({
                cashDrawer: '',
              })
            );
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['menuDisplayPreference'] && changes['menuDisplayPreference'].currentValue) {
      this.menuDisplayPreference = changes['menuDisplayPreference'].currentValue;
      this.updateMenuDisplayPreference();
    }
  }

  navigateToHome(iframe = false) {
    if (iframe) {
      this.navigateTo(this.secureCatalogueService.getLandingPage(iframe), false, false);
    } else {
      this.navigateTo(this.secureCatalogueService.getLandingPage());
    }
    this.layoutService.setIsComponentHidden(false);
    this.spotlightElement?.iFrameAssignment(false);
    this.spotlightElement?.setInitialTabIndex();
  }

  navigateTo(url, isSearch = false, isMyOrder = false) {
    if (this.hasUnsavedChanges) {
      this.dialogService
        .confirm(
          `Are you sure you want to leave this page? Select No to go back and save your update,
          or select Yes to leave this page and discard your changes.
          You have unsaved changes!`
        )
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((val) => {
          if (val) {
            this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
            this.hasUnsavedChanges = false;
            this.router.navigateByUrl(url);
          }
        });
    } else {
      this.router.navigateByUrl(url);
    }

    if (this.router.url === '/pos/customers/search' && isSearch) {
      window.location.reload();
    } else if (this.router.url === '/pos/my-orders/current' && isMyOrder) {
      window.location.reload();
    }
  }

  drawerToggle() {
    this.drawer.toggle();
    this.drawerStatus = !this.drawerStatus;
  }

  setTempDisplayPreference(value) {
    if (value === 'MAX') {
      this.drawer?.open();
      this.menuHide = true;
      this.tempDisplayPreference = true;
    }
  }

  setShowArbAccountSubMenu(value) {
    this.isShowArbAccountSubMenu = value;
    this.onScroll(value);
  }

  setShowPreferencesSubMenu(value) {
    this.isShowPreferencesSubMenu = value;
    this.onScroll(value);
  }

  setDisplayPreference(value) {
    if (value === 'MAX') {
      this.menuHide = true;
      this.isAutoHide = false;
      this.isMinimized = false;
    } else if (value === 'MIN') {
      this.menuHide = false;
      this.isAutoHide = false;
      this.isMaximized = false;
    } else {
      this.menuHide = false;
      this.isAutoHide = false;
      this.isMinimized = false;
    }

    this.menuDisplayPreference = value;
    const userProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
    localStorage.setItem(KEYS.jdeSession, JSON.stringify({ ...userProfile, menuDisplayPreference: value }));
    if (value === 'MIN') {
      this.drawer?.close();
    } else if (value === 'MAX') {
      setTimeout(() => {
        this.drawer?.open();
      }, 200);
    } else {
      this.drawer?.close();
    }
  }

  forInternalUser(role) {
    return role.indexOf(USER_ROLE.internal) !== -1;
  }

  forInternalUserOnly(role) {
    return role === USER_ROLE.internal;
  }

  // Handle router events to update menu display preferences
  private handleRouterEvents() {
    if (
      this.router.url.match(/(\/pos\/scheduler\/?)/g) ||
      this.router.url.match(/(\/central\/?)/g) ||
      (!this.router.url.match(/(\/pos\/?)/g) && !this.router.url.match(/(\/epc\/?)/g))
    ) {
      this.showSpotlightNav = false;
      if (this.menuDisplayPreference === 'MAX') {
        this.hoverStatus = true;
        this.drawer?.open();
        this.menuHide = true;
      }
    } else if (this.isMaximized) {
      this.showSpotlightNav = true;
      this.hoverStatus = true;
      this.drawer?.close();
      this.menuHide = false;
    } else {
      this.showSpotlightNav = true;
    }
  }

  // Update menu display preference based on the current value
  private updateMenuDisplayPreference() {
    if (this.menuDisplayPreference === 'MAX') {
      this.isMaximized = true;
      this.isMinimized = false;
      this.isAutoHide = false;
    } else if (this.menuDisplayPreference === 'MIN') {
      this.isMinimized = true;
      this.isMaximized = false;
      this.isAutoHide = false;
    }
  }

  onScroll(event) {
    if (event) {
      this.navBarComponent.setToolTipPositionAfterScroll();
    }
  }

  async switchBranch() {
    this.store.pipe(select(getParkedOrderListLength), takeUntil(this.unSubscribe$)).subscribe((length) => {
      if (length > 0) {
        this.hasParkedOrder = true;
      }else{
        this.hasParkedOrder = false;
      }
    });

    if (this.isIncompleteOrder || this.hasLoadedGiftCards || this.isElectron || this.hasActiveOrder || this.hasParkedOrder) {
      this.dialogService
        .alert(
          `${
            this.hasActiveOrder || this.isIncompleteOrder
              ? 'You must finalise the order before switching branch.'
              : this.hasParkedOrder
              ? 'Close your parked orders and finalise your changes before switching branch.'
              : ' You must close your cash drawer before switching branch.'
          }`,
          this.isIncompleteOrder || this.hasActiveOrder || this.hasParkedOrder
            ? `${this.hasActiveOrder ? `ACTIVE ORDER` : this.isIncompleteOrder ? `INCOMPLETE ORDER` : 'PARKED ORDER'}`
            : 'GIFTCARDS LOADED'
        )
        .pipe(take(1))
        .subscribe();
    } else {
      this.apiService
        .getBranchList()
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((branchList) => {
          this.branchList = branchList.SearchResults;
          this.modalService.open(this.modalBox, { size: 'xl', backdrop: 'static' }).result.then(
            (_) => {},
            (_) => {}
          );
        });
    }
  }
  cancel() {
    this.modalService.dismissAll();
  }

  submitChangeBranch() {
    if (this.changeBranchForm.valid) {
      const branchCode = this.changeBranchForm.get('branchCode').value;
      this._loading$.next(true);
      this.modalService.dismissAll();
      this.apiService
        .switchSite({ site: branchCode })
        .pipe(
          takeUntil(this.unSubscribe$),
          finalize(() => this._loading$.next(false))
        )
        .subscribe({
          next: (branch) => {
            if (branch) {
              //toast success message
              //this.toastr.success('Branch switched successfully');
              this.isChangeBranch = false;
              const previousUserProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
              const userProfile = {
                ...previousUserProfile,
                DefaultBranch: branch?.newSiteCode,
                DefaultBranchName: branch?.newSiteDescription,
                newSiteCode: true,
              };
              this.messageService.dispatchAction(resetAllFlags());

              localStorage.setItem(KEYS.jdeSession, JSON.stringify(userProfile));

              //reload the page
              window.location.reload();
              //toast after reload
            } else {
              this.toastr.error('No branch found. Failed to switch branch');
              this.changeBranchForm.get('branchCode').setErrors({ notFound: true });
            }
          },
          error: (err) => {
            this.toastr.error(err?.ErrorMessage || 'Failed to switch branch. Please try again.');
          },
        });
    } else {
      this.changeBranchForm.markAllAsTouched();
    }
  }

  parkedOrderChangedErrorDialog() {
    return this.dialogService
      .confirm(`You cannot logout! You have park orders, please deal with them to logout`, `ERROR: Cannot Logout With Parked Orders`, `OKAY`, null)
      .pipe(
        switchMap((val) => {
          if (!!val) {
            return of(this.navigateTo('/pos/my-orders/current'));
          }
          return of(null);
        })
      );
  }

  checkIsParkedOrderChanged(parkOrderList) {
    return parkOrderList.some((parkedOrder) => parkedOrder.orderChangedYN === 'Y');
  }
}
